<template>
  <div class="OrderItem d-flex flex-column">
    <div class="img-wrapper flex-grow-1 ske">
      <img :src="src">
    </div>

    <div class="p-2">
      <div class="d-flex justify-content-between name-wrapper">
        <h5>
          <span class="ske name-ellipsis">
            {{ name }}
          </span>

          <span v-if="!disableRemoval" class="close ske" @click="$emit('remove')">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
          </span>
        </h5>
      </div>
      <div>
        <span class="ske">
          {{ `€ ${price}` }}
        </span>
      </div>
      <div class="d-flex justify-content-between info">
        <span>
          <span class="ske">  
            {{ `${qty} producten` }}
          </span>
        </span>
        <span>
          <span class="ske">
            {{ sku }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    disableRemoval: Boolean,
    
    name: String,
    price: [String, Number],
    qty: Number,
    sku: String,
    src: String,
  },
}

</script>

<style scoped>

.OrderItem {
  height: 250px;
  width: 260px;
  border: 1px solid #E3E3E3;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.OrderItem + .OrderItem {
  margin-left: 12px;
}

.name-ellipsis {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 270px;
}

.img-wrapper {
  position: relative;
}

img {
  position: absolute;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.info {
  font-size: 0.8125em;
  color: rgb(130,130,130);
  margin-top: 1px;
}

h5 {
  margin: 0;
}

.name-wrapper {
  position: relative;
}

.close {
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
}

</style>
